import { axiosPrivate } from "../../api/axios";
import handleError from "../../hooks/handleError";



// Save Settings ("Save Changes")
const saveSettings = (settings) => {

    let isMounted = true;
    const controller = new AbortController();

    const SettingsToInsert = settings.filter((row) => row.actions === "INSERT");
    const SettingsToUpdate = settings.filter((row) => row.actions === "UPDATE");
    const SettingsToDelete = settings.filter((row) => row.actions === "DELETE");

    const insertSettings = async (SettingsToInsert) => {
        try {
            await axiosPrivate.post("/Settings",
                SettingsToInsert,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    const updateSettings = async (SettingsToUpdate) => {
        try {
            await axiosPrivate.put("/Settings",
                SettingsToUpdate,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    const deleteSettings = async (SettingsToDelete) => {
        try {
            await axiosPrivate.delete("/Settings",
                SettingsToDelete,
                { signal: controller.signal }
            );
        } catch (err) {
            handleError(err);
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }

    if (SettingsToDelete.length > 0) { deleteSettings(SettingsToDelete) };
    if (SettingsToInsert.length > 0) { insertSettings(SettingsToInsert) };
    if (SettingsToUpdate.length > 0) { updateSettings(SettingsToUpdate) };

};
export default saveSettings